export const articleStatuses = {
	APPROVED: "Approved",
	DRAFT: "Draft",
	PENDING: "Pending",
	REJECTED: "Rejected",
	UNPUBLISHED: "Unpublished",
	DELETED: "Deleted",
};
